export default __webpack_public_path__ + "powered_by_google_inverse.dc18e3f796f04a9fb8700f32565ffec8.png";